export default class SeasonalCalendar {
    constructor(seasonal = {}){
        this.id = seasonal.id ? seasonal.id : -9999
        this.nameCalendar = seasonal.nameCalendar ? seasonal.nameCalendar : ""
        this.revision = seasonal.revision ? seasonal.revision : ""
        this.month = seasonal.month ? seasonal.month : ""
    }
}